import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {activationSteps} from "constants/constants";

const CourierActivationStepFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false
}) => {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            {showLabel && <h5>{t("fields.activationStep", {ns: "common"})}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="activationStep"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
            >
                {showAllOption ? (
                    <SelectField.Option data-testid="activationStep_option" value={"all"}>
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
                {activationSteps
                    ?.filter(activationStep => {
                        if (showAllOption) return activationStep.value !== "all";
                        return true;
                    })
                    ?.map(activationStep => (
                        <SelectField.Option
                            data-testid="activationStep_option"
                            value={activationStep.value}
                        >
                            {t(activationStep.translation_key, {
                                ns: "activationSteps"
                            })}
                        </SelectField.Option>
                    ))}
            </SelectField>
        </React.Fragment>
    );
};

export default CourierActivationStepFilter;
